import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled.form`
  width: 100%;
  margin: 0 auto;
  max-width: ${pxToRem(450)};
  display: flex;
  flex-direction: column;
  height: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    margin-top: ${pxToRem(10)};
    min-height: ${pxToRem(300)};
  }
`;
